export default {
  MISSING_TITLE: 'MISSING_TITLE'
}
